import React from 'react'
import { FaFacebook, FaInstagram, FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';

const Contactos = () => {
    
    const urlFaceBook = `https://www.facebook.com/profile.php?id=100091346803277&mibextid=ZbWKwL`
    const urlInstagram = `https://instagram.com/infernalparadise9?igshid=NjNlMDhmYTc=`
    const urlWhatsAppMessaje = `https://api.whatsapp.com/send/?phone=+57-313 3517257&text=Hola Infernal Paradise, deseo información`
    const urlTelegram = `https://t.me/IP_tecnologia`

    return (
        <div className="div-social-networks">
            <a href={urlFaceBook} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#FFF" }}>
                <FaFacebook className='icons-principal' />
            </a>
            <a href={urlInstagram} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#FFF" }}>
                <FaInstagram className='icons-principal' />
            </a>
            <a href={urlWhatsAppMessaje} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#FFF" }}>
                <FaWhatsapp className='icons-principal' />
            </a>
            <a href={urlTelegram} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#FFF" }}>
                <FaTelegramPlane className='icons-principal' />
            </a>
        </div>
    )
}

export default Contactos